import * as rdd from 'react-device-detect'

export const useMobileAppContent = () => {
    const containerStyle = {
        // backgroundColor: 'custom.dropDownBackground',
        textAlign: 'center',
        padding: '20px',
        display: 'flex',
        height: '80px',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '8px',
        marginBottom: '8px',
    }
    const downloadAppStatement = {
        typography: 'label1',
    }
    const userUseIOS = rdd.isIOS
    const userUseAndroid = rdd.isAndroid

    return {
        containerStyle,
        downloadAppStatement,
        userUseIOS,
        userUseAndroid,
    }
}
